import { useContext } from 'react';

import Button from '@frolight/components/Button';
import SnackbarContext from '@frolight/context/SnackbarProvider';

const Snackbar = () => {

  const {
    message,
    action,
    type
  } = useContext(SnackbarContext);

  return (
    <div
      className={ `snackbar  snackbar--${type}` }
      role="alert"
    >
      <div className="snackbar__message">
        { message }
      </div>
      {
        action &&
        <div className="snackbar__action">
          <Button
            label={ action.label }
            inverse={ true }
            onClick={ action.callback }
          />
        </div>
      }
    </div>
  );

};

export default Snackbar;